'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ARROW_WIDTH = _constants2.default.ARROW_WIDTH;


var modifierConfig = {
  bottom: function bottom() {
    return '\n    left: 50%;\n    top: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n    transform: translateX(-50%);\n  ';
  },

  left: function left() {
    return '\n    right: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n    top: 50%;\n    transform: translateY(-50%);\n  ';
  },

  right: function right() {
    return '\n    left: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n    top: 50%;\n    transform: translateY(-50%);\n  ';
  },

  top: function top() {
    return '\n    left: 50%;\n    bottom: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n    transform: translateX(-50%);\n  ';
  }
};

var styles = function styles(_ref) {
  var theme = _ref.theme,
      zIndex = _ref.zIndex;
  return '\n  align-items: center;\n  background-color: ' + theme.colors.base.chrome700 + ';\n  border-radius: ' + theme.dimensions.borderRadius + ';\n  ' + theme.planes.sky1 + ';\n  color: ' + theme.colors.base.chrome000 + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  font-weight: ' + theme.fontWeights.light + ';\n  padding: 5px 20px;\n  position: absolute;\n  white-space: nowrap;\n  z-index: ' + zIndex + ';\n';
};

var propTypes = {
  zIndex: _propTypes2.default.number
};

var defaultProps = {
  zIndex: 1
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome000: _propTypes2.default.string.isRequired,
      chrome700: _propTypes2.default.string.isRequired,
      shadow: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    borderRadius: _propTypes2.default.string.isRequired
  }).isRequired,
  fontWeights: _propTypes2.default.shape({
    light: _propTypes2.default.number.isRequired
  }).isRequired
};

var Content = (0, _decisivUiUtils.buildStyledComponent)('Tooltip__Content', _styledComponents2.default.div, styles, {
  defaultProps: defaultProps,
  modifierConfig: modifierConfig,
  propTypes: propTypes,
  themePropTypes: themePropTypes
});

exports.default = Content;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/Tooltip/Content.js
// module id = 1697
// module chunks = 2